(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-collection-nav"] && !Shopify.designMode) return;
  try {
    (function() {
  function updateActiveSubcat() {
    const params = new URLSearchParams(window.location.search);
    const activeType = params.get('filter.p.product_type');
    document.querySelectorAll('.ls-subcat').forEach(function(link) {
      const linkParams = new URLSearchParams(new URL(link.href).search);
      const linkType = linkParams.get('filter.p.product_type');
      const isActive = activeType && linkType === activeType;
      link.classList.toggle('ls-subcat--active', isActive);
      link.style.opacity = isActive ? '1' : '0.5';
    });
  }

  updateActiveSubcat();

  // Intercepte pushState ET replaceState (Horizon utilise replaceState pour les filtres)
  ['pushState', 'replaceState'].forEach(function(method) {
    const original = history[method].bind(history);
    history[method] = function() {
      original.apply(history, arguments);
      updateActiveSubcat();
    };
  });

  window.addEventListener('popstate', updateActiveSubcat);

  // Fallback : écoute les événements custom d'Horizon
  document.addEventListener('shopify:section:load', updateActiveSubcat);
  window.addEventListener('filters:updated', updateActiveSubcat);
})();
  } catch(e) { console.error(e); }
})();

})();
